import { Role } from '@ps20/bff-models';

export enum Origin {
  AZAM = 'AZAM',
  AO = 'AO',
  SDW = 'SDW',
}

export interface RoleDeterminedPayload {
  role: Role;
}

export function isAzam(role: string): boolean {
  return getAzamRoles().some(azamRole => role === azamRole);
}

export function getAzamRoles(): Role[] {
  return [
    Role.NEBENBERUFSVERTRETER,
    Role.AGENTURANGESTELLTER,
    Role.MAKLER,
    Role.UVM,
    Role.MAKLERBETREUER,
    Role.LEITENDER_KUNDENBETREUER,
    Role.VTTEL,
    Role.VTGEV,
    Role.VTKUS,
    Role.VTKVM,
    Role.GENO,
    Role.OLB,
    Role.UWPSHRK,
    Role.UNDERWRITER_UNFALL,
  ];
}

export function getAzamRolesWithoutVtkus(): Role[] {
  return [
    Role.NEBENBERUFSVERTRETER,
    Role.AGENTURANGESTELLTER,
    Role.MAKLER,
    Role.UVM,
    Role.MAKLERBETREUER,
    Role.LEITENDER_KUNDENBETREUER,
    Role.VTTEL,
    Role.VTKVM,
    Role.VTGEV,
    Role.GENO,
    Role.OLB,
    Role.UWPSHRK,
    Role.UNDERWRITER_UNFALL,
  ];
}
export function isMaklerbetreuerOrMaklerOrUvm(role: string): boolean {
  return role === Role.MAKLERBETREUER || role === Role.MAKLER || role === Role.UVM;
}

export function isMaklerbetreuerMaklerVttelOrVtgev(role: string): boolean {
  return (
    role === Role.MAKLERBETREUER ||
    role === Role.MAKLER ||
    role === Role.UVM ||
    role === Role.VTGEV ||
    role === Role.VTKVM ||
    role === Role.VTTEL
  );
}

export function isVertreter(role: string): boolean {
  return role === Role.VERTRETER;
}
export function isVertreterOrNebenberufsvertreter(role: string): boolean {
  return isVertreter(role) || role === Role.NEBENBERUFSVERTRETER;
}

export function determineOriginFromRole(role: string, isSdwSession?: boolean): Origin {
  if (isAzam(role)) {
    return Origin.AZAM;
  }
  if (isVertreter(role)) {
    return isSdwSession ? Origin.SDW : Origin.AO;
  }
  return undefined;
}

export function isVertriebstelefonie(role: string): boolean {
  return role === Role.VTTEL || role === Role.VTGEV || role === Role.VTKVM || role === Role.VTKUS;
}
